import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

interface IHttpResponse {
  error_code: number;
  error_msg: string;
  data: any;
}

interface IGetQuickMessageList {
  quick_message_group_ids?: Array<number>;
  create_user_ids?: Array<number>;
  only_self?: number;
  page?: number;
  page_size?: number;
}

const GET_QUICK_MESSAGE_GROUP_LIST_API = 'api/quick_message/group_list';
const GET_QUICK_MESSAGE_LIST_API = 'api/quick_message/list';

@Injectable()
export class SearchQuickNewsService {

  constructor(
    private http: HttpClient,
  ) { }

  /** 快捷消息分组列表 */
  getQuickMessageGroupList() {
    const query = new HttpParams();
    return this.http.get(GET_QUICK_MESSAGE_GROUP_LIST_API, {
      params: query
    }) as Observable<IHttpResponse>;
  }

  /** 获取快捷消息列表 */
  getQuickMessageList(params: IGetQuickMessageList) {
    const query = new HttpParams()
      .append('quick_message_group_ids', `${params.quick_message_group_ids}`)
      .append('create_user_ids', `${params.create_user_ids}`)
      .append('only_self', `${params.only_self}`)
      .append('page', `${params.page}`)
      .append('page_size', `${params.page_size}`);
    return this.http.get(GET_QUICK_MESSAGE_LIST_API, {
      params: query
    }) as Observable<IHttpResponse>;
  }
}
